import React, { Component, useState } from 'react';
import Select from 'react-select';
import DineInTableRepository from './repository/DineInTableRepository';
import { TableType } from './merchant/Enum/TableType';
class TableSearchComponent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      error: null,
      dataFetched: false,
      data: [] ,
      list: [],
      link: null,
    }

    this.callbackKey = "TableSearchComponent" + Math.random()
  }

  componentWillUnmount() {
    DineInTableRepository.getInstance().removeCallback(null, this)
  }

  componentDidMount() {
    let url = `/merchant/${this.props.merchantId}/tables?with_qr=1`
    if (this.props.type == "pick-up-table") {
      url = `/tables/${this.props.pickupTableId}/pickup_tables?page=1`
      DineInTableRepository.getInstance().loadOne(this.props.pickupTableId, tables => {
        const list = (tables || []).map(t => { return {value: t.id, label: t.name}} )

        // Auto select if only got one table to choose from
        let selectedOption = this.state.selectedOption
        if (list.length == 1) {
          selectedOption = list[0]
          this.props.onChange && this.props.onChange(selectedOption)
        }

        this.setState({
          dataFetched: true,
          data: tables,
          selectedOption,
          list,
        })
      }, this.callbackKey, this)
      return
    }

    fetch(url)
        .then(res => res.json())
        .then(
          (response) => {

            let tables = []
            let list = []
            const filterFunc = t => {
              // Return only table of Dine In (Public)
              return t.table_type_bitwise == TableType.BIT_DINEIN
            }
            if (this.props.type == "pick-up-table") {
              tables = (response.data || []).filter(filterFunc)
              list = tables.map(t => { return {value: t.id, label: t.name}} )
            }
            else {
              tables = (response.data || []).filter(x => x.status == 'active') // && x.table_type_bitwise == 1 
                .filter(filterFunc)
              
              list = tables.map(t => { return {value: t.table_qr.code, label: t.name}} )
            }

            list.sort((a, b) => a.label.localeCompare(b.label, 'en-US', { sensitivity: 'base', numeric: true}))

            this.setState({
              dataFetched: true,
              data: tables,
              list,
            })
          },
          (error) => {
            this.setState({
              dataFetched: true,
              error
            })
          }
        )
  }

  handleChange = (selectedOption) => {
    this.setState({
      selectedOption,
      link : selectedOption && selectedOption.value || null,
    })

    this.props.onChange && this.props.onChange(selectedOption)
  }

  checkSelected = () => {
    if (this.state.link != null) {
      this.setState({
        isRedirecting: true
      }, () => {
        window.location.href = "/category/" + this.state.link
      })
    }
    else{
      alert("Please select a table first!")
    }
  }

  render() {
    const { list } = this.state
      return (
        <>
          {
            list.length == 1 ?
            <strong>{`${lang.table} ${this.state.selectedOption.label}`}</strong> :
            <Select
              blurInputOnSelect={this.props.blurInputOnSelect}
              onChange={this.handleChange}
              className="col-xs-12 .col-sm-6 .col-lg-8 text-left"
              classNamePrefix="select"
              isDisabled={this.props.isDisabled}
              isClearable={this.props.isClearable}
              placeholder={this.props.placeholder}
              isSearchable={this.props.isSearchable}
              name="Select"
              value={this.state.selectedOption}
              options={list}
            />
          }

            {
              !this.props.hideProceedButton &&
              <button disabled={this.state.isRedirecting} type="button" className="mainpg-btn" style={{marginTop: "15px", marginLeft: "0px"}} onClick={this.checkSelected}>{this.state.isRedirecting ? <span>{lang.loading} <i className="fa fa-spinner fa-spin"/></span> : lang.proceed}</button>
            }
        </>
      )
  }
}
TableSearchComponent.defaultProps = {
  isClearable: true,
  blurInputOnSelect: false,
  placeholder: "Select Your Location...",
  isSearchable: true,
  isDisabled: false,
}

export default TableSearchComponent